import React, { useState } from 'react'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { createContent } from '../../../Web Apis/webApis'
import Load from '../../Load/Load'
import { FaArrowLeft } from 'react-icons/fa'

const AddContentPage = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState({
        title: '',
        content: '',
        type: 'other',
        isPublished: true
    })

    const contentTypes = [
        { value: 'privacy-policy', label: 'Privacy Policy' },
        { value: 'terms-conditions', label: 'Terms & Conditions' },
        { value: 'about-us', label: 'About Us' },
        { value: 'faq', label: 'FAQ' },
        { value: 'other', label: 'Other' }
    ]

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        // Validate required fields
        if (!formData.title.trim()) {
            message.error("Please enter a title for the content")
            return
        }

        if (!formData.content.trim()) {
            message.error("Please enter content")
            return
        }

        if (!formData.type) {
            message.error("Please select a content type")
            return
        }

        try {
            setLoading(true)

            const response = await createContent(formData)
            if (response?.data?.success) {
                message.success(response?.data?.message || "Content created successfully")
                navigate('/admin/content')
            }

        } catch (error) {
            console.log("Error while creating content", error.message)
            message.error(error?.response?.data?.message || "Error while creating content")
        } finally {
            setLoading(false)
        }
    }

    const handleGoBack = () => {
        navigate('/admin/content')
    }

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-4">
                        <button
                            onClick={handleGoBack}
                            className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-200"
                        >
                            <FaArrowLeft className="mr-2" />
                            Back to Content
                        </button>
                        <h1 className="text-3xl font-bold text-gray-800">Add New Content</h1>
                    </div>
                </div>

                {/* Main Form */}
                <div className="bg-white rounded-lg shadow-md p-6">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Form Fields */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Title */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Title <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleInputChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Enter content title"
                                    required
                                />
                            </div>

                            {/* Type */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    name="type"
                                    value={formData.type}
                                    onChange={handleInputChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                >
                                    {contentTypes.map(type => (
                                        <option key={type.value} value={type.value}>
                                            {type.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Content */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Content <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                name="content"
                                value={formData.content}
                                onChange={handleInputChange}
                                rows={15}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter content here..."
                                required
                            />
                        </div>

                        {/* Published Checkbox */}
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                name="isPublished"
                                id="isPublished"
                                checked={formData.isPublished}
                                onChange={handleInputChange}
                                className="mr-2"
                            />
                            <label htmlFor="isPublished" className="text-sm font-medium text-gray-700">
                                Publish immediately
                            </label>
                        </div>

                        {/* Preview Section */}
                        {formData.content && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Preview
                                </label>
                                <div className="border border-gray-300 rounded-md p-4 bg-gray-50 max-h-64 overflow-y-auto">
                                    <div dangerouslySetInnerHTML={{ __html: formData.content }} />
                                </div>
                            </div>
                        )}

                        {/* Submit Buttons */}
                        <div className="flex justify-end space-x-4 pt-6 border-t">
                            <button
                                type="button"
                                onClick={handleGoBack}
                                className="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition duration-200"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            >
                                {loading ? "Creating..." : "Create Content"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {loading && <Load />}
        </div>
    )
}

export default AddContentPage

